// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_1s7DGT","overlay--hidden":"_3_Sui6","transparent":"_23_c5Z"};